import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M8 11.973c2.5 -1.473 5.5 -.973 7.5 .527","key":"svg-1"}],["path",{"d":"M9 15c1.5 -1 4 -1 5 .5","key":"svg-2"}],["path",{"d":"M7 9c2 -1 6 -2 10 .5","key":"svg-3"}]]

const IconBrandSpotify = createReactComponent('outline', 'brand-spotify', 'BrandSpotify', __iconNode);

export default IconBrandSpotify;